export class BrokerMandateSignaturesRequestModel {
  filter_state: ('PENDING' | 'APPROVED' | 'REJECTED_WRONG_SIGNATURE' | 'REJECTED_WRONG_DATA')[] = null;
  page: number = 0;
  page_size: number = 25;
}
